export default __webpack_public_path__ + "static/media/I80.b0dbaa5e.jpg";